import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
// Docs: https://armour.github.io/vue-typescript-admin-docs/features/components/rich-editor.html#tinymce
import 'tinymce/tinymce';
import 'tinymce/themes/silver'; // Import themes
import 'tinymce/themes/mobile';
import 'tinymce/plugins/advlist'; // Any plugins you want to use has to be imported
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/code';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/image';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/noneditable';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/print';
import 'tinymce/plugins/save';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/spellchecker';
import 'tinymce/plugins/tabfocus';
import 'tinymce/plugins/table';
import 'tinymce/plugins/template';
import 'tinymce/plugins/textpattern';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';
import TinymceEditor from '@tinymce/tinymce-vue'; // TinyMCE vue wrapper
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { SettingsModule } from '@/store/modules/settings';
import EditorImageUpload from './components/EditorImage.vue';
import { plugins, toolbar } from './config';
var defaultId = function defaultId() {
  return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
};
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "id", void 0);
    _defineProperty(_this, "toolbar", void 0);
    _defineProperty(_this, "menubar", void 0);
    _defineProperty(_this, "height", void 0);
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "hasChange", false);
    _defineProperty(_this, "hasInit", false);
    _defineProperty(_this, "fullscreen", false);
    // https://www.tiny.cloud/docs/configure/localization/#language
    // and also see langs files under public/tinymce/langs folder
    _defineProperty(_this, "languageTypeList", {
      en: 'en',
      ko: 'ko_KR'
    });
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "language",
    get: function get() {
      return this.languageTypeList[AppModule.language];
    }
  }, {
    key: "uploadButtonColor",
    get: function get() {
      return SettingsModule.theme;
    }
  }, {
    key: "tinymceContent",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.$emit('input', value);
    }
  }, {
    key: "containerWidth",
    get: function get() {
      var width = this.width;
      // Test matches `100`, `'100'`
      if (/^[\d]+(\.[\d]+)?$/.test(width.toString())) {
        return "".concat(width, "px");
      }
      return width;
    }
  }, {
    key: "initOptions",
    get: function get() {
      var _this2 = this;
      return {
        selector: "#".concat(this.id),
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: false,
        toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
        menubar: this.menubar,
        plugins: plugins,
        language: this.language,
        language_url: this.language === 'en' ? '' : "".concat(process.env.VUE_APP_BASE_API, "/tinymce/langs/").concat(this.language, ".js"),
        skin_url: "".concat(process.env.VUE_APP_BASE_API, "/tinymce/skins"),
        emoticons_database_url: "".concat(process.env.VUE_APP_BASE_API, "/tinymce/emojis.min.js"),
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        nonbreaking_force_tab: true,
        init_instance_callback: function init_instance_callback(editor) {
          if (_this2.value) {
            editor.setContent(_this2.value);
          }
          _this2.hasInit = true;
          editor.on('NodeChange Change KeyUp SetContent', function () {
            _this2.hasChange = true;
            _this2.$emit('input', editor.getContent());
          });
        },
        setup: function setup(editor) {
          editor.on('FullscreenStateChanged', function (e) {
            _this2.fullscreen = e.state;
          });
        }
      };
    }
  }, {
    key: "onLanguageChange",
    value: function onLanguageChange() {
      var _this3 = this;
      var tinymceManager = window.tinymce;
      var tinymceInstance = tinymceManager.get(this.id);
      if (this.fullscreen) {
        tinymceInstance.execCommand('mceFullScreen');
      }
      if (tinymceInstance) {
        tinymceInstance.destroy();
      }
      this.$nextTick(function () {
        return tinymceManager.init(_this3.initOptions);
      });
    }
  }, {
    key: "imageSuccessCBK",
    value: function imageSuccessCBK(arr) {
      var tinymce = window.tinymce.get(this.id);
      arr.forEach(function (v) {
        tinymce.insertContent("<img class=\"wscnph\" src=\"".concat(v.url, "\" >"));
      });
    }
  }]);
}(Vue);
__decorate([Prop({
  required: true
})], default_1.prototype, "value", void 0);
__decorate([Prop({
  default: defaultId
})], default_1.prototype, "id", void 0);
__decorate([Prop({
  default: function _default() {
    return [];
  }
})], default_1.prototype, "toolbar", void 0);
__decorate([Prop({
  default: 'file edit insert view format table'
})], default_1.prototype, "menubar", void 0);
__decorate([Prop({
  default: '360px'
})], default_1.prototype, "height", void 0);
__decorate([Prop({
  default: 'auto'
})], default_1.prototype, "width", void 0);
__decorate([Watch('language')], default_1.prototype, "onLanguageChange", null);
default_1 = __decorate([Component({
  name: 'Tinymce',
  components: {
    EditorImageUpload: EditorImageUpload,
    TinymceEditor: TinymceEditor
  }
})], default_1);
export default default_1;